class ProductMediaGallery extends HTMLElement {
  constructor() {
    super();
    this.embla = null;
    this.options = {
      loop: false,
      align: 'start',
    };
    this.dots = [];
    this.currentIndex = 0;

    // Bind the reinit handler
    this.handleReinit = this.handleReinit.bind(this);
  }

  connectedCallback() {
    this.initializeSlider();
    this.addEventListener('gallery:reinit', this.handleReinit);
  }

  disconnectedCallback() {
    if (this.embla) {
      this.embla.destroy();
    }
    this.removeDotListeners();
    this.removeEventListener('gallery:reinit', this.handleReinit);
  }

  handleReinit() {
    // Destroy existing slider if it exists
    if (this.embla) {
      this.embla.destroy();
    }

    // Remove existing dot listeners
    this.removeDotListeners();

    // Reinitialize the slider
    this.initializeSlider();

    // Scroll to first slide
    this.embla.scrollTo(0);
  }

  initializeSlider() {
    const emblaNode = this.querySelector('.embla');

    this.embla = EmblaCarousel(emblaNode, this.options);

    this.setupDots();
    this.embla.on('select', this.updateDots.bind(this));
  }

  setupDots() {
    this.dots = Array.from(this.querySelectorAll('.thumbnail-nav button'));
    this.boundOnDotClick = this.onDotClick.bind(this);
    this.dots.forEach((dot) => {
      dot.addEventListener('click', this.boundOnDotClick);
    });
    this.updateDots();
  }

  updateDots() {
    const selectedIndex = this.embla.selectedScrollSnap();
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('tw-ring-2', index === selectedIndex);
      dot.classList.toggle('tw-ring-primary-brand-red', index === selectedIndex);
    });
    this.currentIndex = selectedIndex;
  }

  onDotClick(event) {
    const dot = event.target.closest('button');
    if (!dot) return;

    const index = parseInt(dot.dataset.index, 10);
    if (index !== this.currentIndex) {
      this.dots[this.currentIndex].classList.remove('tw-ring-2', 'tw-ring-primary-brand-red');
      dot.classList.add('tw-ring-2', 'tw-ring-primary-brand-red');
      this.embla.scrollTo(index);
      this.currentIndex = index;
    }
  }

  removeDotListeners() {
    this.dots.forEach((dot) => {
      dot.removeEventListener('click', this.boundOnDotClick);
    });
  }
}

customElements.define('product-media-gallery', ProductMediaGallery);
